export const UNLOCK_ACTIONS = "UNLOCK_ACTIONS";
export const LOCK_ACTIONS = "LOCK_ACTIONS";
export const SHOW_OTP_MODAL = "SHOW_OTP_MODAL";
export const HIDE_OTP_MODAL = "HIDE_OTP_MODAL";
